import { Grid, Button } from "@mui/material";
import { useState } from "react";
import { useAppDispatch } from "../../redux";
import { CustomModal } from "../CompletionPage/CustomModal";
import { setQueueTypeAction } from "./QueueSlice";

export function StartQueue() {
  const dispatch = useAppDispatch();

  const [modal, setModal] = useState<boolean>(false);

  const setQueueType = (type: string) => {
    dispatch(setQueueTypeAction(type));
    setModal(true);
  };

  return (
    <Grid justifyContent={"center"} alignItems={"center"} spacing={3} sx={{ height: "800px" }} container>
      <CustomModal modal={modal} handleClose={() => setModal(false)} type={"queue"} />
      <Grid item xs={7} xl={7} sx={{ height: "40%" }}>
        <Button
          sx={{ width: "100%", height: "100%", fontSize: 30 }}
          variant="contained"
          onClick={() => setQueueType("survivors_portal")}
        >
          Survivor's Portal Queue
        </Button>
      </Grid>
      <Grid item xs={7} xl={7} sx={{ height: "40%" }}>
        <Button
          sx={{ width: "100%", height: "100%", fontSize: 30 }}
          variant="contained"
          onClick={() => setQueueType("paneem")}
        >
          Paneem Queue
        </Button>
      </Grid>
    </Grid>
  );
}
